import React from 'react';
import { Typography } from '@mui/material';
import { unauthorized } from '../assets/images/index';
import DeleteIcon from '../assets/images/deletePopup.svg';
interface UnauthorizedProps {
  message?: any;
}
const Unauthorized: React.FC<UnauthorizedProps> = ({ message }) => {
  return (
    <div className="unauthorized">
      <div
        className={
          message ? 'unauthorized-subscription_image' : 'unauthorized-image'
        }
      >
        <img src={unauthorized} alt="unauthorizedimage" />
      </div>
      <div
        className={
          message ? 'unauthorized-subscription_text' : 'unauthorized-text'
        }
      >
        <img src={DeleteIcon} alt={`Warning Icon`} width="32" />
        <Typography variant="h4">
          <b>Warning: Access Denied</b>
        </Typography>
        <Typography variant="body1">
          {message ? (
            <b>{message}</b>
          ) : (
            <b>You do not have permission to view this page.</b>
          )}
        </Typography>
        <Typography variant="body1">
          <b>Contact the site administrator for assistance.</b>
        </Typography>
      </div>
    </div>
  );
};

export default Unauthorized;
